import React, { useEffect, useState } from "react";
import TitleComponent from "../../../global/Custom/TitleComponent/TitleComponent";

import { Card, Col, Row, Modal, Form, Input, Button, message } from "antd";
import { dispatch, useSelector } from "../../../redux/store";
import { getOtherType, updateOtherType } from "../../../redux/action/otherType";
import { Home_Banner } from "../../../utils/formatType";
import Loading from "../../../global/item/Loading/loading";
import { useTranslation } from "react-i18next";

function BannerHomePage() {
  const { t } = useTranslation();
  const { otherTypeList } = useSelector((state) => state.otherType);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
const [currentItem, setCurrentItem] = useState<typeof otherTypeList[0] | null>(null);
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(getOtherType(Home_Banner))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);

  const openUpdateModal = (item:any) => {
    setCurrentItem(item);
    form.setFieldsValue({
      title: item.title,
      description: item.description,
    });
    setOpenModal(true);
  };

const handleSubmit = async () => {
  const values = await form.validateFields();

  if (!currentItem) return;

  try {
    await dispatch(
      updateOtherType({
        id: Number(currentItem.id),
        a: {
          title: values.title,
          description: values.description,
          type: Home_Banner,
        },
      })
    );

    message.success(t("Cập nhật thành công!"));
    setOpenModal(false);
    await     dispatch(getOtherType(Home_Banner))
  } catch (error) {
    message.error(t("Cập nhật thất bại!"));
  }
};


  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <TitleComponent title={t("Tiêu đề")} type="primary" />
          <Card
            className="layoutItem"
            style={{ cursor: "pointer" }}
            onClick={() =>
              otherTypeList.length > 0
                ? openUpdateModal(otherTypeList[0])
                : null
            }
          >
            <h3 style={{ color: `var(--primary-color)`, marginBottom: 8 }}>
              {t("basicInformation")}
            </h3>

            <Row gutter={[20, 0]}>
              {otherTypeList.length > 0 &&
                otherTypeList.slice(0, 1).map((item) => (
                  <div key={item.id}>
                    <Col xl={24}>
                      <p className="tilteForm">{t("Tiêu đề")}</p>
                      <p className="descForm" style={{ width: "100%" }}>
                        {item.title}
                      </p>
                    </Col>

                    <Col xl={24}>
                      <p className="tilteForm">{t("Mô tả")}</p>
                      <p className="descForm" style={{ width: "100%" }}>
                        {item.description}
                      </p>
                    </Col>
                  </div>
                ))}
            </Row>
          </Card>
        </div>
      )}

      {/* MODAL UPDATE */}
      <Modal
        title={t("Cập nhật thông tin")}
        open={openModal}
        onCancel={() => setOpenModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setOpenModal(false)}>
            {t("Hủy")}
          </Button>,
          <Button key="ok" type="primary" onClick={handleSubmit}>
            {t("Lưu")}
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label={t("Tiêu đề")}
            name="title"
            rules={[{ required: true, message: t("Không được để trống") }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={t("Mô tả")}
            name="description"
            rules={[{ required: true, message: t("Không được để trống") }]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default BannerHomePage;
